import { initWebVitalsTelemetry } from "./web-vitals";
import { initMobileNav } from "./nav";
import { initScrollReveal } from "./scroll-reveal";
import { getBrowserInfo } from "./browser-info";
import { trackEvent } from "./ga-events";

(function () {
  "use strict";

  initWebVitalsTelemetry();
  initMobileNav({ headerId: "header", toggleSelector: ".nav-toggle", linksId: "nav-links", backdropId: "nav-backdrop" });
  initScrollReveal();

  // CTA clicks to sign-in (Start free, Get started, etc.)
  document.querySelectorAll('a[href*="/Auth/SignIn"], a[href*="/SignIn"]').forEach(function (link) {
    link.addEventListener("click", function () {
      var label = (this.textContent || "").trim().slice(0, 50);
      trackEvent("sign_up_start", { source: "stackora_landing", cta: label || "link" });
    });
  });

  // Smooth scroll for same-page anchor links (focus for a11y)
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      var id = this.getAttribute("href");
      if (id === "#") return;
      var target = document.querySelector(id);
      if (target) {
        target.setAttribute("tabindex", "-1");
        target.focus({ preventScroll: true });
      }
    });
  });

  // Contact form (lander)
  var contactForm = document.getElementById("contactForm");
  if (contactForm) {
    var contactMessage = document.getElementById("contactFormMessage");
    var contactSubmitBtn = contactForm.querySelector("#contactSubmitBtn");
    var recaptchaKey = contactForm.getAttribute("data-recaptcha-key") || "";

    function showContactMessage(text, isError) {
      if (!contactMessage) return;
      contactMessage.textContent = text;
      contactMessage.hidden = false;
      contactMessage.classList.remove("success", "error");
      contactMessage.classList.add(isError ? "error" : "success");
    }

    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var nameEl = document.getElementById("contactName");
      var emailEl = document.getElementById("contactEmail");
      var messageEl = document.getElementById("contactMessage");
      var tokenEl = document.getElementById("contactRecaptchaToken");
      var name = (nameEl && nameEl.value) ? nameEl.value.trim() : "";
      var email = (emailEl && emailEl.value) ? emailEl.value.trim() : "";
      var message = (messageEl && messageEl.value) ? messageEl.value.trim() : "";
      if (!name || !email || !message) {
        showContactMessage("Please fill in all required fields.", true);
        return;
      }
      if (contactSubmitBtn) contactSubmitBtn.disabled = true;
      showContactMessage("Sending…", false);

      function done(success, msg) {
        showContactMessage(msg, !success);
        if (contactSubmitBtn) contactSubmitBtn.disabled = false;
        if (success && contactForm) contactForm.reset();
      }

      function runSubmit(recaptchaToken) {
        var body = { name: name, email: email, message: message, source: "lander", browserInfo: getBrowserInfo() };
        if (recaptchaToken) body.recaptchaToken = recaptchaToken;
        fetch("/Contact/Send", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (r.ok && r.data.success) {
              trackEvent("landing_contact_sent", {});
              done(true, r.data.message || "Thanks! Your message was sent.");
            } else {
              done(false, (r.data && r.data.error) || "Something went wrong. Please try again.");
            }
          })
          .catch(function () {
            done(false, "Network error. Please try again.");
          });
      }

      if (recaptchaKey && window.grecaptcha && window.grecaptcha.enterprise) {
        window.grecaptcha.enterprise.execute(recaptchaKey, { action: "contact" })
          .then(function (token) {
            if (tokenEl) tokenEl.value = token;
            runSubmit(token);
          })
          .catch(function () {
            runSubmit("");
          });
      } else {
        runSubmit("");
      }
    });
  }
})();
